import React from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * HCAHPS Star Rating (1–5 stars).
 * Based on HCAHPS Fact Sheet, April 2022 — Star Rating scale.
 */
export default function HcahpsStars({ stars = 0, size = 14, className, testid, showValue = false }) {
  const s = Math.max(0, Math.min(5, Number(stars) || 0));
  return (
    <span className={cn("inline-flex items-center gap-0.5", className)} data-testid={testid || "hcahps-stars"}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          size={size}
          className={cn(
            "transition-colors",
            i < s ? "fill-[#EAB308] text-[#EAB308]" : "text-muted-foreground/40"
          )}
          strokeWidth={1.5}
        />
      ))}
      {showValue && <span className="ml-1 text-xs text-muted-foreground">{s}/5</span>}
    </span>
  );
}
